import * as service from './service'
export default {
  namespace: 'recruitApplyChangeCity',
  state: {
    applyChangeCityData: {},
    itemCheckData: {}
  },
  effects: {
    * applyChangeCity ({ payload }, { call, put }) {
      const res = yield call(service.applyChangeCity, payload)
      yield put({
        type: 'save',
        payload: {
          applyChangeCityData: res.data
        }
      })
      return res.data
    },
    * itemCheckV2 ({ payload }, { call, put }) {
      const res = yield call(service.itemCheckV2, payload)
      yield put({
        type: 'save',
        payload: {
          itemCheckData: res.data.data
        }
      })
      return res.data
    },
    * enable ({ payload }, { call, put }) {
      const res = yield call(service.enable, payload)
      return res.data.data
    },
    * activationScoreEnable ({ payload }, { call, put }) {
      const res = yield call(service.activationScoreEnable, payload)
      return res.data
    },
    * changeCityLimit ({ payload }, { call, put }) {
      const res = yield call(service.changeCityLimit, payload)
      return res.data
    },
    * status ({ payload }, { call, put }) {
      const res = yield call(service.status, payload)
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
